
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class InformativeSmsGrid extends Serenity.EntityGrid<InformativeSmsRow, any> {
        protected getColumnsKey() { return InformativeSmsColumns.columnsKey; }
        protected getDialogType() { return InformativeSmsDialog; }
        protected getIdProperty() { return InformativeSmsRow.idProperty; }
        protected getInsertPermission() { return InformativeSmsRow.insertPermission; }
        protected getLocalTextPrefix() { return InformativeSmsRow.localTextPrefix; }
        protected getService() { return InformativeSmsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}